import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-tabitpay-ticket-seated',
    templateUrl: './tabitpay-ticket-seated.component.html',
    styleUrls: ['./tabitpay-ticket-seated.component.scss'],
    standalone: false
})
export class TabitpayTicketSeatedComponent implements OnInit, OnDestroy {
	@Input() $storage;
	@Input() workMode;
	@Output() onTicketAction = new EventEmitter<any>();

	isUS: boolean;
	args: any = {}

	private orderSubscription: Subscription = null;
	private checkSubscription: Subscription = null;

	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public dialogsService: DialogsService,
	) {
		this.isUS = this.appService.region == 'US';

	}

	ngOnInit() {
		this.checkOrder();
		this.orderSubscription = this.tabitPayService.orderChanged$.subscribe(() => {
			this.checkOrder();
		});
		this.checkSubscription = this.tabitPayService.checkChanged$.subscribe(() => {
			this.checkOrder();
		});
	}

	ngOnDestroy() {
		this.orderSubscription.unsubscribe();
		this.checkSubscription.unsubscribe();
	}

	checkOrder() {
		if (this.isUS) {
			let totalTips = (_.get(this.$storage.order.totals, 'totalTips', 0) - _.get(this.$storage.order.totals, 'totalServiceCharge', 0));
			this.args.totalTips = totalTips / 100;


			let totalDiscounts = this.$storage.order.printData.variables.TOTAL_DISCOUNTS;
			if (totalDiscounts && !isNaN(totalDiscounts)) {
				this.args.totalDiscounts = Number(totalDiscounts);
			} else {
				delete this.args.totalDiscounts;
			}

		}
	}

	_onTicketAction(args) {
		this.onTicketAction.emit(args);
	}


}
